module.exports = __webpack_public_path__ + "img/Group-36561.7248a171.svg";